import { useState } from 'react';
import './OffersPage.css';
const importAll = (r) => {
  return r.keys().map(r);
};
const julia_images = importAll(require.context('../assets/Julia', false, /\.(png|jpe?g|svg)$/));
const olmos_images = importAll(require.context('../assets/Olmos', false, /\.(png|jpe?g|svg)$/));
const huisache_images = importAll(require.context('../assets/Huisache', false, /\.(png|jpe?g|svg)$/));
const camden_images = importAll(require.context('../assets/Camden', false, /\.(png|jpe?g|svg)$/));


const properties = [
  {
    id: 1,
    title: 'Scenic Downtown Home',
    description: 'Stunning 3BR house in the heart of downtown San Antonio. Full kitchen, private parking, and minutes from the Alamo. Enjoy the Tower of Americas from the patio!',
    images: julia_images,
    price: '$120/night',
    link: 'https://avoproperties.lodgify.com'
  },
  {
    id: 2,
    title: 'North Downtown Gem',
    description: 'Charming 2BR home located near the Pearl and San Antonio Zoo. Perfect for a relaxing getaway for you and your crew.',
    images: olmos_images,
    price: '$100/night',
    link: 'http://airbnb.com/h/olmosretreat'
  },
  {
    id: 3,
    title: 'Retreat at Woodlawn Lake',
    description: 'Escape to the historic Woodlawn Lake neighborhood of San Antonio; great for cooking large meals with the family. Enjoy the outdoors under a mature Pecan tree while you grill and chill!',
    images: huisache_images,
    price: '$130/night',
    link: 'http://airbnb.com/h/sanantoniohuisacheloft'
  },
  {
    id: 4,
    title: 'Sea World San Antonio',
    description: 'Planning to visit Sea World with your gang? This home is perfectly situated for your lodging accomodations. ',
    images: camden_images,
    price: '$105/night',
    link: 'http://airbnb.com/h/home-by-lackland-seaworld'
  },
];

const PropertyCard = ({ property }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => 
      prev === property.images.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => 
      prev === 0 ? property.images.length - 1 : prev - 1
    );
  };

  const handleCardClick = () => {
    window.open(property.link, '_blank');
  };

  return (
    <div className="property-card" onClick={handleCardClick}>
      <div className="carousel">
        <img 
          src={property.images[currentImageIndex]} 
          alt={`${property.title} -${currentImageIndex + 1}`}
          className="carousel-image"
        />
        <button className="carousel-btn prev" onClick={prevImage}>
          &#10094;
        </button>
        <button className="carousel-btn next" onClick={nextImage}>
          &#10095;
        </button>
        <div className="carousel-indicators">
          {property.images.map((_, index) => (
            <span 
              key={index} 
              className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                setCurrentImageIndex(index);
              }}
            />
          ))}
        </div>
      </div>
      <div className="property-info">
        <div className="property-header">
          <h3 className="property-title">{property.title}</h3>
          <span className="property-price">{property.price}</span>
        </div>
        <p className="property-description">{property.description}</p>
      </div>
    </div>
  );
};

const OffersPage = () => {
  return (
    <div className="offers-page">
      <h1 className="offers-header">Featured San Antonio Properties</h1>
      <div className="properties-list">
        {properties.map((property) => (
          <PropertyCard key={property.id} property={property} />
        ))}
      </div>
    </div>
  );
};

export default OffersPage;
